import React, { Component } from 'react';
import { Player } from 'video-react';

import Skeleton from 'components/common/Skeleton'
import ImagePlaceholder from 'components/common/ImagePlaceholder'

import './VideoCardPlayer.css'
import '../../../../../node_modules/video-react/dist/video-react.css';

class VideoCardPlayer extends Component {
	constructor(props) {
		super(props);

		const { poster } = props;

		this.state = {
			isLoading: true,
			isEditing: false,
			thumbnailUrl: poster,
			error: null,
			nestedItemsOpen: false,
		};

		this.image = new Image();
	}

	loadThumbnail = () => {
		let { image } = this;
		const { thumbnailUrl } = this.state;

		if (thumbnailUrl) {
			image.onload = () => this.setState({
				isLoading: false,
				thumbnailUrl,
				error: null
			});

			image.onerror = () => this.setState({
				isLoading: false,
				thumbnailUrl,
				error: new Error("Videovorschau konnte nicht geladen werden")
			});

			image.src = thumbnailUrl;

		} else {
			this.setState({
				isLoading: false,
				thumbnailUrl: null,
				error: new Error("Vorschau wird geladen...") // Keine Bildvorschau verfügbar
			});
		}
	};

	componentDidMount() {
		this.loadThumbnail();
	}

	componentWillReceiveProps(nextProps) {
		/* pre-load poster image */
		const { poster } = nextProps;

		if (poster && poster !== this.state.thumbnailUrl) {
			this.setState({
				...this.state,
				thumbnailUrl: poster
			}, () => this.loadThumbnail());
		}
	}

	componentWillUnmount() {
		const { image } = this;
		// reset handlers, otherwise get triggered again once image is unmounted
		image.onload = null;
		image.onerror = null;
	}

	installGTMTrigger = () => {
		const { id = "" } = this.props;

		// set element id
		this.player.video.video.id = id;

		window.dataLayer.push({
			"event": "video-metadata-loaded",
			"eventLabel": id
		}); // make GTM variable available
	};

	render() {
		const { isLoading, error } = this.state;
		const { src, poster } = this.props;

		const renderPlayer = () => (
			<div className="video-card-player-container">
				<div className="video-card-player">
					<Player
						ref={c => this.player = c}
						playsInline
						poster={poster}
						src={src}
						position="center"
						preload="metadata"
						fluid
						onLoadedMetadata={this.installGTMTrigger}
					/>
				</div>
			</div>
		);

		return (
			<div>
				{ isLoading && <Skeleton height={180} /> }
				{ error && <ImagePlaceholder icon={"videocam"} title={error.message} /> }
				{ !isLoading && !error && renderPlayer() }
			</div>
		)
	}
}

export default VideoCardPlayer;


// WEBPACK FOOTER //
// ./src/components/cards/video/v1/VideoCardPlayer.jsx